import ModelService from './model.service';

const CompanyService = new ModelService('/companies', '/users/companies', 'companies');

CompanyService.getImage = (filename, w = false, h = false, c = false) => CompanyService.getFilePathByDir('/uploads/companies', filename, w, h, c);

CompanyService.STATUS_INACTIVE = 0;
CompanyService.STATUS_ACTIVE = 1;

CompanyService.getStatusList = t => ({
  [CompanyService.STATUS_INACTIVE]: t('Inactive'),
  [CompanyService.STATUS_ACTIVE]: t('Active'),
});

CompanyService.getStatusOptions = t => CompanyService
  .prepareOptionsFromSimpleObject(CompanyService.getStatusList(t));

CompanyService.getStatusTitle = (status, t) => {
  const label = CompanyService.getStatusList(t)[status];
  return label || '-';
};

CompanyService.getColorByStatus = (status) => {
  switch (status) {
    case CompanyService.STATUS_INACTIVE:
      return 'danger';
    case CompanyService.STATUS_ACTIVE:
      return 'success';
    default:
      return 'secondary';
  }
};

CompanyService.PAYMENT_STATUS_PAID = 1;
CompanyService.PAYMENT_STATUS_NOT_PAID = 0;
CompanyService.PAYMENT_STATUS_PENDING = 2;
CompanyService.PAYMENT_STATUS_FREE_TRIAL = 3;
CompanyService.PAYMENT_STATUS_CANCEL = 4;

CompanyService.getPaymentStatusList = t => ({
  [CompanyService.PAYMENT_STATUS_PAID]: t('Paid'),
  [CompanyService.PAYMENT_STATUS_NOT_PAID]: t('Not paid'),
  [CompanyService.PAYMENT_STATUS_PENDING]: t('Pending'),
  [CompanyService.PAYMENT_STATUS_FREE_TRIAL]: t('Trial'),
  [CompanyService.PAYMENT_STATUS_CANCEL]: t('Cancelled'),
});

CompanyService.getPaymentStatusOptions = t => CompanyService
  .prepareOptionsFromSimpleObject(CompanyService.getPaymentStatusList(t), true);

CompanyService.getPaymentStatusTitle = (status, t) => {
  const label = CompanyService.getPaymentStatusList(t)[status];
  return label || '-';
};

CompanyService.getColorByPaymentStatus = (status) => {
  switch (status) {
    case CompanyService.PAYMENT_STATUS_PAID:
      return 'success';
    case CompanyService.PAYMENT_STATUS_FREE_TRIAL:
      return 'success';
    case CompanyService.PAYMENT_STATUS_NOT_PAID:
      return 'danger';
    case CompanyService.PAYMENT_STATUS_PENDING:
      return 'warning';
    case CompanyService.PAYMENT_STATUS_CANCEL:
      return 'warning';
    default:
      return 'secondary';
  }
};

CompanyService.PAYMENT_TYPE_STRIPE = 1;
CompanyService.PAYMENT_TYPE_MANUAL = 2;

CompanyService.getPaymentsTypeList = t => ({
  [CompanyService.PAYMENT_TYPE_STRIPE]: 'Stripe',
  [CompanyService.PAYMENT_TYPE_MANUAL]: t('Manual'),
});

CompanyService.getColorByPaymentType = (status) => {
  switch (status) {
    case CompanyService.PAYMENT_TYPE_STRIPE:
      return 'warning';
    case CompanyService.PAYMENT_TYPE_MANUAL:
      return 'secondary';
    default:
      return 'secondary';
  }
};

CompanyService.getPaymentTypesOptions = t => CompanyService
  .prepareOptionsFromSimpleObject(CompanyService.getPaymentsTypeList(t));

CompanyService.getPaymentTypesTitle = (status, t) => {
  const label = CompanyService.getPaymentsTypeList(t)[status];
  return label || '-';
};

CompanyService.PAYMENT_PERIOD_TYPE_YEAR = 2;
CompanyService.PAYMENT_PERIOD_TYPE_MONTH = 1;

CompanyService.getPaymentsPeriodTypeList = t => ({
  [CompanyService.PAYMENT_PERIOD_TYPE_MONTH]: t('Month'),
  [CompanyService.PAYMENT_PERIOD_TYPE_YEAR]: t('Year'),
});

CompanyService.getPaymentPeriodTypesOptions = t => CompanyService
  .prepareOptionsFromSimpleObject(CompanyService.getPaymentsPeriodTypeList(t));

CompanyService.getPaymentPeriodTypesTitle = (status, t) => {
  const label = CompanyService.getPaymentsPeriodTypeList(t)[status];
  return label || '-';
};

export default CompanyService;



// WEBPACK FOOTER //
// ./src/services/company.service.js